import React, { useState } from 'react'
import Booking01 from "../assets/booking-gallery-01.png";
import Gallery01 from '../assets/gallery-01.png';
import Gallery02 from '../assets/gallery-02.png';
import Gallery03 from '../assets/gallery-03.png';
import Gallery04 from '../assets/gallery-04.png';
import GalleryModal from './GalleryModal';

const HotelGallery = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="position-relative z-4 pt-5 pb-5">
      <div className="container">
        <div className="top-gallery-box">
          <div className="gallery-grid d-flex flex-wrap gap-3">
            <div className="left-gallery-grid">
              <div className="img-box">
                <img src={Booking01} alt="" />
              </div>
            </div>
            <div className="right-gallery-grid">
              <div className="right-four-column-grid d-flex flex-wrap gap-3">
                <div className="gallery-grid-box">
                  <div className="img-box">
                    <img src={Gallery01} alt="" />
                  </div>
                </div>
                <div className="gallery-grid-box">
                  <div className="img-box">
                    <img src={Gallery02} alt="" />
                  </div>
                </div>
                <div className="gallery-grid-box">
                  <div className="img-box">
                    <img src={Gallery03} alt="" />
                  </div>
                </div>
                <div
                  className="gallery-grid-box"
                  onClick={() => setShowModal(true)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="img-box">
                    <img src={Gallery04} alt="" />
                  </div>
                  <span>24+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GalleryModal show={showModal} onClose={() => setShowModal(false)} />

    </div>
  )
}

export default HotelGallery
